export const importFromCsv = {
  title: 'CSV Import washing method',
  importSuccessfully: 'Import washing method successfully!',
  importFailed: 'Import washing method failed!',
}
